import { render, staticRenderFns } from "./preauthortip.vue?vue&type=template&id=3095e6d4&scoped=true"
import script from "./preauthortip.vue?vue&type=script&lang=js"
export * from "./preauthortip.vue?vue&type=script&lang=js"
import style0 from "./preauthortip.vue?vue&type=style&index=0&id=3095e6d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095e6d4",
  null
  
)

export default component.exports